var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { cols: "3", xs: "3", sm: "2", md: "1" },
        },
        [_vm._t("name")],
        2
      ),
      _vm._l(_vm.values, function (value, i) {
        return _c(
          "v-col",
          {
            key: i,
            staticClass: "px-2",
            attrs: { cols: "4", xs: "4", md: "5" },
          },
          [
            value != "not selected"
              ? _c(
                  "v-card",
                  { staticClass: "pa-2", attrs: { color: _vm.color(value) } },
                  [_vm._v(" " + _vm._s(value) + " ")]
                )
              : _vm._e(),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }